class PermissionChecker {
	constructor(rights) {
		this.rights = rights;
	}

	allows(swaggerRoute) {
		// Check rule for route without "*"
		let checkCurrentRule = this.checkRule(swaggerRoute);
		if (checkCurrentRule !== null) {
			return checkCurrentRule ? swaggerRoute : false;
		}

		// If route not exists, check sub routes with "*"
		let routes = swaggerRoute.split(".");
		let partsRouteToRemove = "";
		let partsRoute = swaggerRoute;

		// Return first parent result
		for (let i = routes.length; i > 0; i--) {
			if (routes[i]) {
				partsRouteToRemove += "." + routes[i];
				partsRoute = swaggerRoute.substring(0, swaggerRoute.length - partsRouteToRemove.length);
			}

			let rule = `${partsRoute}.*`;
			let checkRule = this.checkRule(rule);
			if (checkRule !== null) {
				return checkRule ? rule : false;
			}
		}

		return false;
	}

	checkRule(swaggerRoute) {
		// Check rule content
		let rule = this.getRightsRule(swaggerRoute);
		if (rule !== false) {
			return rule[0] !== "!";
		}

		return null;
	}

	getRightsRule(swaggerRoute) {
		// Search entity
		for (let right of this.rights) {
			let rule = right.includes(":") ? right.split(":")[0] : right;

			if (rule === swaggerRoute) {
				return right;
			} else if (rule[0] === "!" && rule.substring(1) === swaggerRoute) {
				return right;
			}
		}

		return false;
	}
}

export default PermissionChecker;
